import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Card } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import api from '../../services/api';
import styles from '../../services/styles';
import { displayMessage } from '../../helpers/messages';
import Button from '../../components/buttons/Button';
import Input from '../../components/input/Input';
import { showErrorMessage, showSuccessMessage } from '../../services/messages';
import GeneralContext from '../../context/GeneralContext/GeneralContext';

const { COLORS } = styles;

const ChangePassword = () => {
  const navigate = useNavigate();
  const { loggedUser } = useContext(GeneralContext);
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    if (values.newPassword !== values.confirmPassword) {
      showErrorMessage(displayMessage('ERROR_PASSWORD_MISMATCH'));
      return;
    }

    setLoading(true);

    try {
      if (loggedUser?.must_change_password) {
        // Se é primeira senha, usa changePasswordForced
        await api.auth.changePasswordForced({
          newPassword: values.newPassword
        });
      } else {
        // Senão, usa changePassword normal
        await api.auth.changePassword({
          oldPassword: values.oldPassword,
          newPassword: values.newPassword
        });
      }

      showSuccessMessage(displayMessage('SUCCESS_UPDATE'));

      setTimeout(() => {
        navigate('/');
      }, 2000);
    } catch (error) {
      showErrorMessage(error?.response?.data?.error || displayMessage('ERROR_GENERIC'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      width: '100vw',
      background: COLORS.GRAY[50]
    }}>
      <Card
        title={displayMessage('CHANGE_PASSWORD')}
        style={{ maxWidth: 500, width: '100%', margin: 16 }}
      >
        <Form
          name="change_password"
          onFinish={onFinish}
          layout='vertical'
          requiredMark={false}
        >
          {!loggedUser?.must_change_password && (
            <Form.Item
              label={displayMessage('OLD_PASSWORD')}
              name="oldPassword"
              rules={[{ required: true, message: 'Por favor, informe a senha atual!' }]}
            >
              <Input
                prefix={<LockOutlined />}
                type="password"
                placeholder="Digite a senha atual"
              />
            </Form.Item>
          )}

          <Form.Item
            label={displayMessage('NEW_PASSWORD')}
            name="newPassword"
            rules={[{ required: true, message: 'Por favor, informe a nova senha!' }]}
          >
            <Input
              prefix={<LockOutlined />}
              type="password"
              placeholder="Digite a nova senha"
            />
          </Form.Item>

          <Form.Item
            label={displayMessage('CONFIRM_PASSWORD')}
            name="confirmPassword"
            rules={[{ required: true, message: 'Por favor, confirme a senha!' }]}
          >
            <Input
              prefix={<LockOutlined />}
              type="password"
              placeholder="Confirme a nova senha"
            />
          </Form.Item>

          <Form.Item style={{ marginBottom: 0, marginTop: 24 }}>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              {!loggedUser?.must_change_password && (
                <Button onClick={() => navigate('/')}>
                  {displayMessage('CANCEL')}
                </Button>
              )}
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
              >
                {displayMessage('CONFIRM')}
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default ChangePassword;



